import { render } from "./ImageEditor.vue?vue&type=template&id=5e58f00d"
import script from "./ImageEditor.vue?vue&type=script&lang=js"
export * from "./ImageEditor.vue?vue&type=script&lang=js"

import "./ImageEditor.vue?vue&type=style&index=0&id=5e58f00d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__